"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var thirdOrderApi = _interopRequireWildcard(require("@/api/thirdOrderApi.js"));
var movieOrderApi = _interopRequireWildcard(require("@/api/orderListApi.js"));
var orderListApi = movieOrderApi;
var _transformState = _interopRequireDefault(require("@/utils/transformState.js"));
var _static = require("../static");
var _bindTag = _interopRequireDefault(require("../lists/bindTag.vue"));
var _nextThirdorder = _interopRequireDefault(require("./nextThirdorder.vue"));
var _logDetail = _interopRequireDefault(require("./logDetail.vue"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
var cache;
function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var r, c, a = Object.defineProperty, n = { __proto__: null, default: e }; if (Object(e) !== e) return n; if (cache || "function" != typeof WeakMap || (cache = new WeakMap()), cache) { if (cache.has(e)) return cache.get(e); cache.set(e, n); } for (c in e) "default" !== c && {}.hasOwnProperty.call(e, c) && ((r = a && Object.getOwnPropertyDescriptor(e, c)) && (r.get || r.set) ? a(n, c, r) : n[c] = e[c]); return n; }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'thirdOrderDetail',
  components: {
    BindTag: _bindTag.default,
    NextThirdorder: _nextThirdorder.default,
    LogDetail: _logDetail.default
  },
  props: {
    orderId: {
      type: String,
      default: ''
    }
  },
  data: function data() {
    return {
      dialogVisible: false,
      orderDatalist: {},
      loading: false,
      baseOption: [
      // 订单基础信息
      {
        title: '订单编号',
        dataIndex: 'orderNo'
      }, {
        title: '供应商订单编号',
        dataIndex: 'outTradeNo'
      }, {
        title: '影片名称',
        dataIndex: 'filmName'
      }, {
        title: '影院名称',
        dataIndex: 'cinemaName'
      }, {
        title: '影厅',
        dataIndex: 'hallName'
      }, {
        title: '座位名称',
        dataIndex: 'seatNames'
      }, {
        title: '城市名称',
        dataIndex: 'cityName'
      }, {
        title: '影院地址',
        dataIndex: 'cinemaAddress'
      }, {
        title: '订单金额',
        dataIndex: 'orderPrice'
      }, {
        title: '供应商扣费',
        dataIndex: 'settleAmount'
      }
      // {title: '客户扣费', dataIndex: 'orderPrice'},
      ],
      orderNo: null,
      needRefreshList: 0 // 关闭时是否需要刷新列表 0:不需要 1:需要
    };
  },
  mounted: function mounted() {},
  methods: {
    transformState: _transformState.default,
    openDetail: function openDetail(orderNo) {
      this.orderNo = orderNo;
      this.needRefreshList = 0;
      if (!orderNo) {
        this.$message.warning('未查询到该订单！');
        return;
      }
      this.getOrderData();
    },
    // 获取订单物流信息
    getOrderData: function getOrderData() {
      var _this = this;
      var needRefreshList = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
      this.needRefreshList = needRefreshList;
      this.dialogVisible = true;
      this.loading = true;
      movieOrderApi.getMovieOrderDetail(this.orderNo).then(function (res) {
        _this.orderDatalist = res || {};
        _this.loading = false;
      }).catch(function (err) {
        _this.loading = false;
      });
    },
    // 关闭弹窗，判断是否需要刷新列表
    handleColse: function handleColse() {
      this.needRefreshList == 1 && this.$emit('doRefresh');
      this.dialogVisible = false;
    },
    // 查询订单
    checkOrderState: function checkOrderState() {
      var _this2 = this;
      if (!this.orderNo) return;
      this.loading = true;
      thirdOrderApi.getVirtualState(this.orderNo).then(function (res) {
        _this2.loading = false;
        _this2.$alert("<div style='font-weight: 500; color: #000'>\u6700\u65B0\u72B6\u6001\uFF1A".concat((res === null || res === void 0 ? void 0 : res.statusName) || '--', "</div>"), '查询结果', {
          dangerouslyUseHTMLString: true,
          callback: function () {
            var _callback = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
              return _regenerator().w(function (_context) {
                while (1) switch (_context.n) {
                  case 0:
                    try {
                      _this2.getOrderData();
                    } catch (err) {
                      _this2.$message.error(err.message);
                    }
                    ;
                  case 1:
                    return _context.a(2);
                }
              }, _callee);
            }));
            function callback() {
              return _callback.apply(this, arguments);
            }
            return callback;
          }()
        });
      }).catch(function (err) {
        _this2.loading = false;
      });
    },
    // 查看日志详情
    openReqDetail: function openReqDetail(row) {
      this.$refs['LogDetailRef'].openInit(row);
    },
    syncMovieStatus: function syncMovieStatus() {
      var _this3 = this;
      if (!this.orderNo) return;
      this.loading = true;
      orderListApi.syncMovieStatus(this.orderNo).then(function (res) {
        _this3.loading = false;
        _this3.$message.success('同步成功！');
        _this3.getOrderData();
      }).catch(function (err) {
        _this3.loading = false;
      });
    }
  }
};